import { frontendURL } from '../../../helper/URLHelper';

const ContentTemplatesIndex = () => import('./pages/ContentTemplatesIndex.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/content-templates'),
    name: 'content_templates_index',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: ContentTemplatesIndex,
  },
  {
    path: frontendURL('accounts/:accountId/content-templates/inbox/:inbox_id'),
    name: 'content_templates_inbox',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: ContentTemplatesIndex,
    props: route => ({ inboxId: route.params.inbox_id }),
  },
];
